<template>
  <BaseDropdown>
    <template #trigger="{ isActive }">
      <HeaderIconButton
        :badge="selectedFiltersCount"
        :is-active="isActive"
      >
        <template #icon>
          <FilterCircleSvg />
        </template>
        <template #label>
          Filter
        </template>
      </HeaderIconButton>
    </template>

    <template #content>
      <BaseDropdownHeading>
        <template #default>
          Filter data
        </template>
        <template #lead>
          Description goes here for this
        </template>
        <template #actions>
          <BaseButton
            variant="success"
            :class="$style.actionButton"
            @click="applyFilters"
          >
            Apply filters
          </BaseButton>
          <BaseButton
            variant="secondary"
            :class="$style.actionButton"
            @click="resetAll"
          >
            Reset all
          </BaseButton>
        </template>
      </BaseDropdownHeading>
      <BaseDropdownActionsListRow>
        <BaseDropdownActionsList
          v-for="[columnId, items] in columns"
          :key="columnId"
        >
          <template
            v-for="item in items"
            :key="item.name"
          >
            <BaseDropdownActionField v-if="!['complexity'].includes(item.name)">
              <template #label>
                {{ item.label }}
              </template>

              <template #field>
                <BaseDateInput
                  v-if="item.type === 'dateRange'"
                  :model-value="modelValue[item.name]"
                  :class="$style.filterField"
                  is-range
                  @update:modelValue="setFilterValue(item.name, $event)"
                />
                <BaseMultiselect
                  v-else-if="item.type === 'select'"
                  :model-value="modelValue[item.name]"
                  :options="schemaOptions[item.name]"
                  :class="$style.filterField"
                  is-searchable
                  is-block
                  @update:modelValue="setFilterValue(item.name, $event)"
                />
              </template>
            </BaseDropdownActionField>
          </template>
        </BaseDropdownActionsList>
      </BaseDropdownActionsListRow>
    </template>
  </BaseDropdown>
</template>

<script>
import { cloneDeep } from 'lodash';
import BaseDropdown, {
  DropdownActionField as BaseDropdownActionField,
  DropdownActionsList as BaseDropdownActionsList,
  DropdownActionsListRow as BaseDropdownActionsListRow,
  DropdownHeading as BaseDropdownHeading,
} from '@/components/base/Dropdown';
import BaseMultiselect from '@/components/base/Multiselect';
import BaseDateInput from '@/components/base/DateInput';
import BaseButton from '@/components/base/Button';
import HeaderIconButton from '@/components/HeaderIconButton';
import FilterCircleSvg from '@/assets/images/icons/filter-circle.svg?inline';

export default {
  components: {
    BaseDropdown,
    BaseDropdownHeading,
    BaseDropdownActionsList,
    BaseDropdownActionField,
    BaseDropdownActionsListRow,
    BaseMultiselect,
    BaseDateInput,
    BaseButton,
    HeaderIconButton,
    FilterCircleSvg,
  },
  props: {
    schema: {
      type: Array,
      default: () => [],
    },
    schemaOptions: {
      type: Object,
      default: null,
    },
    modelValue: {
      type: Object,
      default: null,
    },
    resetAll: {
      type: Function,
      default: null,
    },
    applyFilters: {
      type: Function,
      default: null,
    },
  },
  emits: {
    'update:modelValue': null,
  },
  computed: {
    model: {
      get() {
        return cloneDeep(this.modelValue);
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    columns() {
      return this.schema.reduce((c, field) => {
        if (!c.has(field.columnId)) {
          c.set(field.columnId, []);
        }

        const column = c.get(field.columnId);
        column.push(field);

        return c;
      }, new Map());
    },
    selectedFiltersCount() {
      return this.schema.reduce((counter, item) => {
        if (item.type === 'dateRange') {
          const value = this.model[item.name];
          if (value.start != null || value.end != null) return counter + 1;
        } else if (item.type === 'select') {
          if (this.model[item.name].length > 0) return counter + 1;
        }

        return counter;
      }, 0);
    },
  },
  methods: {
    setFilterValue(filter, value) {
      const { model } = this;
      model[filter] = value;
      this.$emit('update:modelValue', model);
    },
  },
};
</script>

<style lang="scss" module>
.filterField {
  width: 260px;
}

.actionButton {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 10px;
  margin-right: 10px;
}
</style>
